import React, { Fragment, useState, useEffect, useContext } from 'react'

import AppContext from '../../../contexts/AppContext'
import Breadcrumbs from '../../Breadcrumbs'
import Header from '../../Header'
import Footer from '../../Footer'
import { LeadForm } from './common'
import { breadcrumbsBy } from '../../../services/locations'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

import { Helmet } from "react-helmet-async";

const Create = ({ match, history }) => {

    const { data, authServices, location } = useContext(AppContext)
    const { user } = data.app

    const title = "Create a lead"

    return (
        <Fragment>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">
                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {url: '/account/leads', title: 'Leads & sales'}, {title}])} />
                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <div className="d-flex justify-content-between">
                            <h1 className="mt-0">{title}</h1>
                            <div className="ms-3">
                                <Link tag="a" to={'/account/leads'} className="btn btn-outline-secondary">
                                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                                    Back to Leads
                                </Link>
                            </div>
                        </div>

                        <LeadForm onCreated={() => {
                            history.push('/account/leads')
                        }} />
                    </div>
                </main>
            </div>
            <Footer />
        </Fragment>
    )
}

export default Create
